import { isProductionBuild } from './build.js'
import { isApiConfigured } from './api.js'

export function getGoogleClientId() {
  return (import.meta.env.VITE_GOOGLE_CLIENT_ID ?? '').trim()
}

export function isAuthDevBypass() {
  if (isProductionBuild()) return false
  return import.meta.env.VITE_AUTH_DEV_BYPASS === 'true'
}

export function getWhoamiPath() {
  const raw = import.meta.env.VITE_AUTH_WHOAMI_PATH
  if (typeof raw === 'string' && raw.trim()) return raw.trim()
  return '/api/me'
}

export function isAuthEnforced() {
  if (isAuthDevBypass()) return false
  if (!isApiConfigured()) return false
  return true
}
